import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  SideNavigation,
  SideNavigationItem,
} from '../../components/SideNavigation';

export const ImportsMenu = React.memo(() => (
  <SideNavigation>
    <SideNavigationItem to="/imports">
      <FormattedMessage id="imports.title" defaultMessage="Imports" />
    </SideNavigationItem>
  </SideNavigation>
));
